"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var models_1 = require("../../models");
var Accessor_1 = require("../../models/Accessor");
var EffectiveDefinition_1 = require("../../models/EffectiveDefinition");
var comparisonEngine_1 = require("./comparisonEngine");
var defaults_1 = require("./defaults");
exports.defaultComparisonSchema = defaults_1.defaultComparisonSchema;
exports.defaultThresholdFeature = defaults_1.defaultThresholdFeature;
exports.defaultThresholdLineStyle = defaults_1.defaultThresholdLineStyle;
exports.defaultThresholdTransform = defaults_1.defaultThresholdTransform;
var models_2 = require("./models");
exports.DeltaLabelStyle = models_2.DeltaLabelStyle;
exports.LineLabelStyle = models_2.LineLabelStyle;
exports.LineStyle = models_2.LineStyle;
var buildComparisonLineLabelAccessor_1 = require("./buildComparisonLineLabelAccessor");
exports.buildComparisonLineLabelAccessor = buildComparisonLineLabelAccessor_1.buildComparisonLineLabelAccessor;
exports.getThresholdFeature = function (features) {
    return features.threshold;
};
exports.buildFirstThresholdMeasureAccessor = function (effectiveDefinition) {
    var feature = exports.getThresholdFeature(effectiveDefinition.features);
    var line = exports.getDefaultLineForThreshold(feature);
    if (!line) {
        return undefined;
    }
    return Accessor_1.accessorForReference(line.measure);
};
exports.buildFirstThresholdTimestampAccessor = function (effectiveDefinition) {
    var _a;
    var feature = exports.getThresholdFeature(effectiveDefinition.features);
    var line = exports.getDefaultLineForThreshold(feature);
    if (!((_a = line) === null || _a === void 0 ? void 0 : _a.timestamp)) {
        return undefined;
    }
    return Accessor_1.accessorForReference(line.timestamp);
};
exports.shouldRenderFirstThresholdLine = function (definition) {
    return exports.shouldRenderFirstThresholdLineFromFeature(exports.getThresholdFeature(definition.features));
};
exports.shouldRenderFirstThresholdLineFromFeature = function (feature) {
    var _a, _b;
    var line = exports.getDefaultLineForThreshold(feature);
    if (!line) {
        return false;
    }
    var hidden = (_b = (_a = line) === null || _a === void 0 ? void 0 : _a.style) === null || _b === void 0 ? void 0 : _b.hidden;
    return hidden ? false : true;
};
exports.getLineStyleForDefaultThresholdLine = function (definition) {
    var _a;
    return (_a = exports.getDefaultLineForThreshold(definition.features.threshold)) === null || _a === void 0 ? void 0 : _a.style;
};
var DASHED_LINESTYLE = {
    strokeDasharray: '1 5',
    strokeLinecap: 'round',
};
exports.getStylePropsForDefaultThresholdLine = function (definition) {
    var _a;
    var lineStyle = exports.getLineStyleForDefaultThresholdLine(definition);
    return ((_a = lineStyle) === null || _a === void 0 ? void 0 : _a.lineStyle) === models_2.LineStyle.DASHED ? DASHED_LINESTYLE : undefined;
};
exports.getDefaultLineForThreshold = function (feature) { var _a, _b, _c, _d; return (_d = (_c = (_b = (_a = feature) === null || _a === void 0 ? void 0 : _a.thresholds) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.lines) === null || _d === void 0 ? void 0 : _d[0]; };
exports.isDefaultLineStaticRefLine = function (definition) {
    var line = exports.getDefaultLineForThreshold(definition.features.threshold);
    if (!line || line.timestamp) {
        return false;
    }
    return EffectiveDefinition_1.isConstantColumn(definition.schema[line.measure.column].calculation);
};
exports.definitionWithStaticTarget = function (definition, value) {
    var _a;
    var columnName = "static_threshold_" + value;
    var newFeatures = __assign(__assign({}, definition.features), { threshold: {
            thresholds: [
                {
                    lines: [
                        {
                            measure: { column: columnName },
                            style: {
                                hidden: false,
                                interactive: false,
                                deltaLabel: models_2.DeltaLabelStyle.TARGET_VALUE,
                                lineStyle: models_2.LineStyle.DASHED,
                                lineLabel: models_2.LineLabelStyle.LATEST_VALUE,
                            },
                        },
                    ],
                },
            ],
        } });
    var newSchema = __assign(__assign({}, definition.schema), (_a = {}, _a[columnName] = {
        type: EffectiveDefinition_1.NumberType,
        name: columnName,
        calculation: {
            type: EffectiveDefinition_1.ConstantType,
            value: value,
        },
    }, _a));
    return __assign(__assign({}, definition), { features: newFeatures, schema: newSchema });
};
exports.definitionWithComparison = function (definition, comparison, hideThresholdLine) {
    var comparisonName = 'comparison';
    var newFeatures = makeFeaturesWithComparison(hideThresholdLine, comparison, definition);
    var newSchema = makeSchemaWithComparison(definition, comparison, comparisonName);
    var newTransforms = makeTableTransformWithComparison(comparison, definition, comparisonName);
    return __assign(__assign({}, definition), { features: newFeatures, schema: newSchema, tableTransforms: newTransforms });
};
var makeFeaturesWithComparison = function (hideThresholdLine, comparison, definition) {
    if (comparisonEngine_1.isNoComparison(comparison)) {
        // No comparison was set so remove the existing thresholds
        return __assign(__assign({}, definition.features), { threshold: {} });
    }
    // For now, we're swapping a new threshold if one already exists because we can (at the moment) only
    // have one threshold applied to a metric
    var newThresholdLine = {
        measure: { column: defaults_1.COMPARISON_MEASURE_COLUMN_NAME },
        timestamp: { column: defaults_1.COMPARISON_TIMESTAMP_COLUMN_NAME },
        style: __assign(__assign({}, defaults_1.defaultThresholdLineStyle()), { hidden: hideThresholdLine }),
    };
    var newThreshold = {
        thresholds: [
            {
                lines: [newThresholdLine],
            },
        ],
    };
    var newFeatures = __assign(__assign({}, definition.features), { threshold: newThreshold });
    return newFeatures;
};
var makeSchemaWithComparison = function (definition, comparison, comparisonName) {
    var _a;
    if (comparisonEngine_1.isNoComparison(comparison)) {
        // No comparison was set so don't modify the schema
        return __assign({}, definition.schema);
    }
    return __assign(__assign({}, definition.schema), (_a = {}, _a[defaults_1.COMPARISON_TIMESTAMP_COLUMN_NAME] = {
        type: 'datetime',
        name: defaults_1.COMPARISON_TIMESTAMP_COLUMN_NAME,
        calculation: {
            type: 'table-calc',
            name: comparisonName,
            source: { column: 'timestamp' },
        },
    }, _a[defaults_1.COMPARISON_MEASURE_COLUMN_NAME] = {
        type: 'number',
        name: defaults_1.COMPARISON_MEASURE_COLUMN_NAME,
        calculation: {
            type: 'table-calc',
            name: comparisonName,
            source: { column: 'measure' },
        },
    }, _a));
};
var makeTableTransformWithComparison = function (comparison, definition, comparisonName) {
    var _a;
    if (comparisonEngine_1.isNoComparison(comparison)) {
        // No comparison was set so remove the existing comparison if it exists
        var transformsWithNoComparison = __assign({}, definition.tableTransforms);
        delete transformsWithNoComparison[comparisonName];
        return transformsWithNoComparison;
    }
    var transform = tableTransformForComparison(comparison);
    var newTransforms = __assign(__assign({}, definition.tableTransforms), (_a = {}, _a[comparisonName] = transform, _a));
    return newTransforms;
};
var tableTransformForComparison = function (comparison) {
    if (comparison.dateTrunc === models_1.DateTrunc.UNKNOWN) {
        return {
            type: 'row-shift',
            amount: comparison.numberOfPeriods,
        };
    }
    else {
        return {
            type: 'time-shift',
            source: { column: 'timestamp' },
            unit: comparison.compareTo,
            amount: comparison.numberOfPeriods,
        };
    }
};
//# sourceMappingURL=index.js.map